import { useEffect } from 'react';

import { twMerge } from 'tailwind-merge';

import { ROUTES } from '@/_navigation/routes';
import { STYLE } from '@/_static/styles';
import { getFormData } from '@/_utils';
import { replaceWithName } from '@/_utils/actions';

import { DangerousText } from '../DangerousText';

import Contact from './components/Contact';
import Select from './components/Select';
import TextArea from './components/TextArea';

export function FormCard({ navigate, currentObj, leadObj, pageCallBack, currentPage, setEnableButton, form }) {
  useEffect(() => {
    if (currentPage === ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY.link) {
      const formData = getFormData() ?? {};
      delete formData.Readiness_Option_1__c;
      delete formData.Readiness_Option_2__c;
      delete formData.Readiness_Option_3__c;
      delete formData.Readiness_Option_4__c;
      delete formData.Readiness_Option_5__c;

      localStorage.setItem('formData', JSON.stringify(formData));
    }
  }, [currentPage]);

  const renderFormInput = () => {
    if (currentObj?.list && currentObj.list.length > 0) {
      return currentObj.list.map((field, index) => {
        if (field.input === 'select') {
          return (
            <Select
              options={field.options}
              currentObj={currentObj}
              key={index}
              pageCallBack={pageCallBack}
              navigate={navigate}
              currentPage={currentPage}
              setEnableButton={setEnableButton}
            />
          );
        }

        if (field.input === 'textarea') {
          return <TextArea currentObj={currentObj} key={field} pageCallBack={pageCallBack} />;
        }

        if (field.input === 'contact_form') {
          return <Contact form={form} key={field} />;
        }
        return null;
      });
    }
    return null;
  };

  return (
    <>
      <div className={currentObj?.bubbleChat ? STYLE.bubbleChat : STYLE.header}>
        <DangerousText>{replaceWithName(currentObj.header, leadObj)}</DangerousText>
      </div>
      {!!currentObj?.subheader && (
        <div
          className={twMerge(STYLE.subHeader, 'my-5 leading-snug')}
          dangerouslySetInnerHTML={{ __html: currentObj.subheader }}
        />
      )}
      <div>{renderFormInput(currentObj)}</div>
    </>
  );
}
